import {FC, useEffect} from "react";
import {useAppSelector} from "../../../../redux/hooks/hook";
import MainCard from "../../../../../_kiloit/helpers/components/MainCard";
import GameTable from "./GameTable";
import {useGame} from "../../core/action";
import {useNavigate} from "react-router-dom";


const GameTableWrapper: FC = () => {
    const game = useAppSelector(state => state.gameState.game);
    const draws = game.listDraw;
    const {fetchListDraw} = useGame();
    const navigate = useNavigate();

    useEffect(() => {
        fetchListDraw().then((res) => {
            const draw = res[0];
            draw && navigate(`/lobby/game/${draw.tableId}/manual`)
        })
        // eslint-disable-next-line 
    }, []);

    return <MainCard
        isShowEmpty={draws.length === 0}
        className="game-table-wrapper w-100"
        labelClass="text-white"
        isLoading={game.loading}>
        <div className="h-100 w-100 overflow-y-scroll overflow-x-hidden">
            <div className="row m-0 mt-1 pb-5">
                {draws.map((draw, i) => {
                    return <GameTable key={i} draw={draw}/>
                })}
            </div>
        </div>
    </MainCard>
}

export default GameTableWrapper;